export class ClinicCodesModel {
    pet_info_proc_no: number
    pet_info_proc_type: number

    constructor(
        pet_info_proc_no: number,
        pet_info_proc_type: number
    ) {
        this.pet_info_proc_no = pet_info_proc_no
        this.pet_info_proc_type = pet_info_proc_type
    }
}